module.exports = __webpack_public_path__ + "static/media/initial_chatwindow.a4c6df56.png";